import {useLocation} from "react-router-dom";

export interface ISongsPageNavigationItemLogic {
  isActive: boolean;
}

/** This function is duplicated elsewhere voaw8ej098rj23 */
function getActiveTabFromLocationPath(locationPath: string): string {
  const parts = locationPath.split("/"); //should result in ["", "songs", "browse", ]
  let activeTab;
  if(parts.length >= 3){
    activeTab = parts[2];
  }
  return activeTab ?? 'home';
}

export const useSongsPageNavigationItemLogic = (navItemPage: string): ISongsPageNavigationItemLogic => {
  const {pathname} = useLocation();
  return {
    isActive: getActiveTabFromLocationPath(pathname) === navItemPage,
  };
}
